import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Content.st.css.js';
import { dataHooks } from '../constants';
import { WixDesignSystemContext } from '../../WixDesignSystemProvider/context';
import { SidePanelContext } from '../SidePanelAPI';
import { useOverlayScrollbar } from '../../providers/useOverlayScrollbar/useOverlayScrollbar';
const Content = ({ children, className, noPadding = false, stretchVertically = true, }) => {
    const [ref, scrollbarClassname] = useOverlayScrollbar();
    return (React.createElement(SidePanelContext.Consumer, null, ({ skin }) => (React.createElement(WixDesignSystemContext.Consumer, null, ({ newColorsBranding }) => (React.createElement("div", { ref: ref, className: st(classes.root, { noPadding, stretchVertically, newColorsBranding, skin }, className, scrollbarClassname), "data-hook": dataHooks.sidePanelContent }, children))))));
};
Content.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    noPadding: PropTypes.bool,
    stretchVertically: PropTypes.bool,
};
export default Content;
//# sourceMappingURL=Content.js.map